var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingsproducticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H0V8.21053H1.35V23.2632C1.35 23.989 1.63446 24.6851 2.14081 25.1984C2.64716 25.7117 3.33392 26 4.05 26H22.95C23.6661 26 24.3528 25.7117 24.8592 25.1984C25.3655 24.6851 25.65 23.989 25.65 23.2632V8.21053H27V0ZM2.7 2.73684H24.3V5.47368H2.7V2.73684ZM22.95 23.2632H4.05V8.21053H22.95V23.2632ZM6.75 18.4053C6.75 17.7447 7.00886 17.1113 7.46964 16.6442C7.93042 16.1771 8.55536 15.9147 9.207 15.9147H9.3285C9.21556 15.3803 9.21122 14.8282 9.31574 14.2921C9.42025 13.7559 9.63144 13.247 9.93641 12.7963C10.2414 12.3456 10.6337 11.9627 11.0895 11.6708C11.5454 11.3789 12.0551 11.1842 12.5876 11.0985C13.12 11.0129 13.6642 11.0381 14.1867 11.1727C14.7093 11.3073 15.1993 11.5483 15.6269 11.8812C16.0545 12.2141 16.4107 12.6318 16.6738 13.1088C16.9369 13.5858 17.1014 14.1122 17.1572 14.6558C17.8501 14.6418 18.5272 14.8663 19.078 15.2926C19.6288 15.7189 20.0208 16.3219 20.19 17.0031C20.3592 17.6844 20.2956 18.4036 20.0096 19.0435C19.7236 19.6834 19.232 20.2061 18.6152 20.5263H7.9245C7.56528 20.305 7.26845 19.9936 7.0627 19.622C6.85695 19.2504 6.74925 18.8314 6.75 18.4053Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingsproducticon);
export default __webpack_public_path__ + "static/media/savingsproducticon.0ebef16f00ae095aa894294dd0aac71b.svg";
export { ForwardRef as ReactComponent };